module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/area_eight-2099d740eea8a490ace5b7d1bf74f0f2.jpg";